const tabs = ({
  tabsConatinerSelector = `.js-tabs`,
  tabSelector = `.js-tabs-tab`,
  itemSelector = `.js-tabs-item`,
  wrapperTabSelector = `.forms__tab-inner`,
  activeClass = `active`,
}) => {
  const tabsContainerElement = document.querySelector(tabsConatinerSelector);

  if (tabsContainerElement) {
    const tabsElements = tabsContainerElement.querySelectorAll(tabSelector);
    const itemsElelements = tabsContainerElement.querySelectorAll(itemSelector);

    let currentTabIndex = 0;

    const deactivateItem = () => {
      tabsElements[currentTabIndex].classList.remove(activeClass);
      itemsElelements[currentTabIndex].classList.remove(activeClass);

      // somoderart fix на остальных проектах можно удалить
      tabsElements[currentTabIndex].closest(wrapperTabSelector).classList.remove(activeClass);
    };

    const activateItem = () => {
      tabsElements[currentTabIndex].classList.add(activeClass);
      itemsElelements[currentTabIndex].classList.add(activeClass);

      // somoderart fix на остальных проектах можно удалить
      tabsElements[currentTabIndex].closest(wrapperTabSelector).classList.add(activeClass);
    };

    tabsElements.forEach((tab, index) => {
      tab.addEventListener(`click`, (evt) => {
        if (currentTabIndex !== index) {
          deactivateItem();

          currentTabIndex = index;

          activateItem();
        }
      });
    });

    window.addEventListener(`DOMContentLoaded`, activateItem);
  }
};

export default tabs;
